import { Formik, Form } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { FaLayerGroup, FaSortNumericDown, FaAlignLeft } from "react-icons/fa";

interface HeaderFormProps {
  initialValues: any;
  validationSchema: any;
  onSubmit: (
    values: any,
    formikHelpers: {
      resetForm: () => void;
    }
  ) => Promise<void>;
  isLoading?: boolean;
}

const HeaderForm: React.FC<HeaderFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => {
        return (
          <Form className="max-w-4xl mx-auto w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Basic Information Card */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-2">
                  <FaLayerGroup className="text-primary" />
                  <h3 className="font-bold text-gray-800 text-lg">
                    Informations de base
                  </h3>
                </div>

                <div className="space-y-4">
                  <div>
                    <label
                      htmlFor="displayName"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Nom de la catégorie
                    </label>
                    <TextField
                      id="displayName"
                      value={values.displayName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      placeholder="Ex: Pizzas, Boissons..."
                      className="w-full"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="description"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Description
                    </label>
                    <TextField
                      id="description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      placeholder="Description courte..."
                      className="w-full"
                    />
                  </div>
                </div>
              </div>

              {/* Settings Card */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 h-fit">
                <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-2">
                  <FaSortNumericDown className="text-primary" />
                  <h3 className="font-bold text-gray-800 text-lg">
                    Paramètres d&apos;affichage
                  </h3>
                </div>

                <div className="space-y-4">
                  <div>
                    <label
                      htmlFor="displayOrder"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Ordre d&apos;affichage
                    </label>
                    <TextField
                      id="displayOrder"
                      value={values.displayOrder}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      placeholder="Ex: 1"
                      className="w-full"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Définit la position de la catégorie dans le menu.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <Button
                className="bg-primary hover:bg-primary-dark text-white px-8 py-2.5 rounded-lg font-bold shadow-sm transition-all transform hover:scale-[1.02] active:scale-[0.98]"
                disabled={isSubmitting || isLoading}
                type="submit"
              >
                {isLoading ? "Enregistrement..." : "Enregistrer la catégorie"}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default HeaderForm;
